import { useCallback } from 'react';

import { useConceptGroups } from '@verantos-dev/data-access-concept-groups';

import { mapConceptGroupNameToId, mapIdToConceptGroupName } from '../helpers/helpers';

export const useConceptGroupsMaps = () => {
  const { conceptGroups } = useConceptGroups();
  const _mapConceptGroupNameToId = useCallback(
    (dsl: string): string => mapConceptGroupNameToId(dsl, conceptGroups),
    [conceptGroups]
  );

  const _mapIdToConceptGroupName = useCallback(
    (dsl: string): string => mapIdToConceptGroupName(dsl, conceptGroups),
    [conceptGroups]
  );

  return { _mapConceptGroupNameToId, _mapIdToConceptGroupName };
};
